/**
 * @generated SignedSource<<31e554af26a9bdda088356712a57bd9a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type portal_HelpCenterPortal$data = {
  readonly description: string | null;
  readonly logo: string | null;
  readonly name: string;
  readonly portalId: string | null;
  readonly " $fragmentType": "portal_HelpCenterPortal";
};
export type portal_HelpCenterPortal$key = {
  readonly " $data"?: portal_HelpCenterPortal$data;
  readonly " $fragmentSpreads": FragmentRefs<"portal_HelpCenterPortal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "portal_HelpCenterPortal",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "logo"
    },
    {
      "kind": "ScalarField",
      "name": "portalId"
    }
  ],
  "type": "HelpLayoutPortalCard"
};

(node as any).hash = "3799a41c8f97aa60a39e5e30cebbea7b";

export default node;
